import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
import { Table } from "./table/Table";
import { TableColumn } from "./table/TableColumn";
import { TableForeignKey } from "./table/TableForeignKey";
import { TableIndex } from "./table/TableIndex";
import { TableUtils } from "./util/TableUtils";
import { TableUnique } from "./table/TableUnique";
import { TableCheck } from "./table/TableCheck";
import { TableExclusion } from "./table/TableExclusion";
import { View } from "./view/View";
import { ViewUtils } from "./util/ViewUtils";
import { DriverUtils } from "../driver/DriverUtils";
/**
 * Creates complete tables schemas in the database based on the entity metadatas.
 *
 * Steps how schema is being built:
 * 1. load list of all tables with complete column and keys information from the db
 * 2. drop all (old) foreign keys that exist in the table, but does not exist in the metadata
 * 3. create new tables that does not exist in the db, but exist in the metadata
 * 4. drop all columns exist (left old) in the db table, but does not exist in the metadata
 * 5. add columns from metadata which does not exist in the table
 * 6. update all exist columns which metadata has changed
 * 7. update primary keys - update old and create new primary key from changed columns
 * 8. create foreign keys which does not exist in the table yet
 * 9. create indices which are missing in db yet, and drops indices which exist in the db, but does not exist in the metadata anymore
 */
export var RdbmsSchemaBuilder = /*#__PURE__*/function () {
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function RdbmsSchemaBuilder(connection) {
    _classCallCheck(this, RdbmsSchemaBuilder);
    this.connection = connection;
    this["@instanceof"] = Symbol.for("RdbmsSchemaBuilder");
  }
  // -------------------------------------------------------------------------
  // Public Methods
  // -------------------------------------------------------------------------
  /**
   * Creates complete schemas for the given entity metadatas.
   */
  _createClass(RdbmsSchemaBuilder, [{
    key: "build",
    value: function () {
      var _build = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this = this;
        var isUsingTransactions, tablePaths, viewPaths;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.queryRunner = this.connection.createQueryRunner();
              // this.connection.driver.database || this.currentDatabase;
              this.currentDatabase = this.connection.driver.database;
              this.currentSchema = this.connection.driver.schema;
              // CockroachDB implements asynchronous schema sync operations which can not been executed in transaction.
              // E.g. if you try to DROP column and ADD it again in the same transaction, crdb throws error.
              // In Spanner queries against the INFORMATION_SCHEMA can be used in a read-only transaction,
              // but not in a read-write transaction.
              isUsingTransactions = !(this.connection.driver.options.type === "cockroachdb") && !(this.connection.driver.options.type === "spanner") && this.connection.options.migrationsTransactionMode !== "none";
              _context.next = 6;
              return this.queryRunner.beforeMigration();
            case 6:
              if (!isUsingTransactions) {
                _context.next = 9;
                break;
              }
              _context.next = 9;
              return this.queryRunner.startTransaction();
            case 9:
              _context.prev = 9;
              _context.next = 12;
              return this.createMetadataTableIfNecessary(this.queryRunner);
            case 12:
              // Flush the queryrunner table & view cache
              tablePaths = this.entityToSyncMetadatas.map(function (metadata) {
                return _this.getTablePath(metadata);
              });
              viewPaths = this.viewEntityToSyncMetadatas.map(function (metadata) {
                return _this.getTablePath(metadata);
              });
              _context.next = 16;
              return this.queryRunner.getTables(tablePaths);
            case 16:
              _context.next = 18;
              return this.queryRunner.getViews(viewPaths);
            case 18:
              _context.next = 20;
              return this.executeSchemaSyncOperationsInProperOrder();
            case 20:
              if (!this.connection.queryResultCache) {
                _context.next = 23;
                break;
              }
              _context.next = 23;
              return this.connection.queryResultCache.synchronize(this.queryRunner);
            case 23:
              if (!isUsingTransactions) {
                _context.next = 26;
                break;
              }
              _context.next = 26;
              return this.queryRunner.commitTransaction();
            case 26:
              _context.next = 39;
              break;
            case 28:
              _context.prev = 28;
              _context.t0 = _context["catch"](9);
              _context.prev = 30;
              if (!isUsingTransactions) {
                _context.next = 34;
                break;
              }
              _context.next = 34;
              return this.queryRunner.rollbackTransaction();
            case 34:
              _context.next = 38;
              break;
            case 36:
              _context.prev = 36;
              _context.t1 = _context["catch"](30);
            case 38:
              throw _context.t0;
            case 39:
              _context.prev = 39;
              _context.next = 42;
              return this.queryRunner.afterMigration();
            case 42:
              _context.next = 44;
              return this.queryRunner.release();
            case 44:
              return _context.finish(39);
            case 45:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[9, 28, 39, 45], [30, 36]]);
      }));
      function build() {
        return _build.apply(this, arguments);
      }
      return build;
    }()
    /**
     * Create the typeorm_metadata table if necessary.
     */
  }, {
    key: "createMetadataTableIfNecessary",
    value: function () {
      var _createMetadataTableIfNecessary = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(queryRunner) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(this.viewEntityToSyncMetadatas.length > 0 || this.hasGeneratedColumns())) {
                _context2.next = 3;
                break;
              }
              _context2.next = 3;
              return this.createTypeormMetadataTable(queryRunner);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createMetadataTableIfNecessary(_x) {
        return _createMetadataTableIfNecessary.apply(this, arguments);
      }
      return createMetadataTableIfNecessary;
    }()
    /**
     * Returns sql queries to be executed by schema builder.
     */
  }, {
    key: "log",
    value: function () {
      var _log = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this2 = this;
        var tablePaths, viewPaths;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.queryRunner = this.connection.createQueryRunner();
              _context3.prev = 1;
              // Flush the queryrunner table & view cache
              tablePaths = this.entityToSyncMetadatas.map(function (metadata) {
                return _this2.getTablePath(metadata);
              });
              viewPaths = this.viewEntityToSyncMetadatas.map(function (metadata) {
                return _this2.getTablePath(metadata);
              });
              _context3.next = 6;
              return this.queryRunner.getTables(tablePaths);
            case 6:
              _context3.next = 8;
              return this.queryRunner.getViews(viewPaths);
            case 8:
              this.queryRunner.enableSqlMemory();
              _context3.next = 11;
              return this.executeSchemaSyncOperationsInProperOrder();
            case 11:
              if (!this.connection.queryResultCache) {
                _context3.next = 14;
                break;
              }
              _context3.next = 14;
              return this.connection.queryResultCache.synchronize(this.queryRunner);
            case 14:
              return _context3.abrupt("return", this.queryRunner.getMemorySql());
            case 15:
              _context3.prev = 15;
              // its important to disable this mode despite the fact we are release query builder
              // because there exist drivers which reuse same query runner. Also its important to disable
              // sql memory after call of getMemorySql() method because last one flushes sql memory.
              this.queryRunner.disableSqlMemory();
              _context3.next = 19;
              return this.queryRunner.release();
            case 19:
              return _context3.finish(15);
            case 20:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1,, 15, 20]]);
      }));
      function log() {
        return _log.apply(this, arguments);
      }
      return log;
    }() // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Returns only entities that should be synced in the database.
     */
  }, {
    key: "entityToSyncMetadatas",
    get: function get() {
      return this.connection.entityMetadatas.filter(function (metadata) {
        return metadata.synchronize && metadata.tableType !== "entity-child" && metadata.tableType !== "view";
      });
    }
    /**
     * Returns only entities that should be synced in the database.
     */
  }, {
    key: "viewEntityToSyncMetadatas",
    get: function get() {
      return this.connection.entityMetadatas.filter(function (metadata) {
        return metadata.tableType === "view" && metadata.synchronize;
      })
      // sort views in creation order by dependencies
      .sort(ViewUtils.viewMetadataCmp);
    }
    /**
     * Checks if there are at least one generated column.
     */
  }, {
    key: "hasGeneratedColumns",
    value: function hasGeneratedColumns() {
      return this.connection.entityMetadatas.some(function (entityMetadata) {
        return entityMetadata.columns.some(function (column) {
          return column.generatedType;
        });
      });
    }
    /**
     * Executes schema sync operations in a proper order.
     * Order of operations matter here.
     */
  }, {
    key: "executeSchemaSyncOperationsInProperOrder",
    value: function () {
      var _executeSchemaSyncOperationsInProperOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.dropOldViews();
            case 2:
              _context4.next = 4;
              return this.dropOldForeignKeys();
            case 4:
              _context4.next = 6;
              return this.dropOldIndices();
            case 6:
              _context4.next = 8;
              return this.dropOldChecks();
            case 8:
              _context4.next = 10;
              return this.dropOldExclusions();
            case 10:
              _context4.next = 12;
              return this.dropCompositeUniqueConstraints();
            case 12:
              _context4.next = 14;
              return this.renameColumns();
            case 14:
              _context4.next = 16;
              return this.createNewTables();
            case 16:
              _context4.next = 18;
              return this.dropRemovedColumns();
            case 18:
              _context4.next = 20;
              return this.addNewColumns();
            case 20:
              _context4.next = 22;
              return this.updatePrimaryKeys();
            case 22:
              _context4.next = 24;
              return this.updateExistColumns();
            case 24:
              _context4.next = 26;
              return this.createNewIndices();
            case 26:
              _context4.next = 28;
              return this.createNewChecks();
            case 28:
              _context4.next = 30;
              return this.createNewExclusions();
            case 30:
              _context4.next = 32;
              return this.createCompositeUniqueConstraints();
            case 32:
              _context4.next = 34;
              return this.createForeignKeys();
            case 34:
              _context4.next = 36;
              return this.createViews();
            case 36:
              _context4.next = 38;
              return this.createNewViewIndices();
            case 38:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function executeSchemaSyncOperationsInProperOrder() {
        return _executeSchemaSyncOperationsInProperOrder.apply(this, arguments);
      }
      return executeSchemaSyncOperationsInProperOrder;
    }()
  }, {
    key: "getTablePath",
    value: function getTablePath(target) {
      var parsed = this.connection.driver.parseTableName(target);
      return this.connection.driver.buildTableName(parsed.tableName, parsed.schema || this.currentSchema, parsed.database || this.currentDatabase);
    }
    /**
     * Drops all (old) foreign keys that exist in the tables, but do not exist in the entity metadata.
     */
  }, {
    key: "dropOldForeignKeys",
    value: function () {
      var _dropOldForeignKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this3 = this;
        var _iterator, _step, _loop, _ret;
        return _regeneratorRuntime().wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _iterator = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context6.prev = 1;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var metadata, table, tableForeignKeysToDrop;
                return _regeneratorRuntime().wrap(function _loop$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      metadata = _step.value;
                      table = _this3.queryRunner.loadedTables.find(function (table) {
                        return _this3.getTablePath(table) === _this3.getTablePath(metadata);
                      });
                      if (table) {
                        _context5.next = 4;
                        break;
                      }
                      return _context5.abrupt("return", "continue");
                    case 4:
                      // find foreign keys that exist in the schemas but does not exist in the entity metadata
                      tableForeignKeysToDrop = table.foreignKeys.filter(function (tableForeignKey) {
                        var metadataFK = metadata.foreignKeys.find(function (metadataForeignKey) {
                          return tableForeignKey.name === metadataForeignKey.name && _this3.getTablePath(tableForeignKey) === _this3.getTablePath(metadataForeignKey.referencedEntityMetadata);
                        });
                        return !metadataFK || metadataFK.onDelete && metadataFK.onDelete !== tableForeignKey.onDelete || metadataFK.onUpdate && metadataFK.onUpdate !== tableForeignKey.onUpdate;
                      });
                      if (!(tableForeignKeysToDrop.length === 0)) {
                        _context5.next = 7;
                        break;
                      }
                      return _context5.abrupt("return", "continue");
                    case 7:
                      _this3.connection.logger.logSchemaBuild("dropping old foreign keys of ".concat(table.name, ": ").concat(tableForeignKeysToDrop.map(function (dbForeignKey) {
                        return dbForeignKey.name;
                      }).join(", ")));
                      // drop foreign keys from the database
                      _context5.next = 10;
                      return _this3.queryRunner.dropForeignKeys(table, tableForeignKeysToDrop);
                    case 10:
                    case "end":
                      return _context5.stop();
                  }
                }, _loop);
              });
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context6.next = 11;
                break;
              }
              return _context6.delegateYield(_loop(), "t0", 6);
            case 6:
              _ret = _context6.t0;
              if (!(_ret === "continue")) {
                _context6.next = 9;
                break;
              }
              return _context6.abrupt("continue", 9);
            case 9:
              _context6.next = 4;
              break;
            case 11:
              _context6.next = 16;
              break;
            case 13:
              _context6.prev = 13;
              _context6.t1 = _context6["catch"](1);
              _iterator.e(_context6.t1);
            case 16:
              _context6.prev = 16;
              _iterator.f();
              return _context6.finish(16);
            case 19:
            case "end":
              return _context6.stop();
          }
        }, _callee5, this, [[1, 13, 16, 19]]);
      }));
      function dropOldForeignKeys() {
        return _dropOldForeignKeys.apply(this, arguments);
      }
      return dropOldForeignKeys;
    }()
    /**
     * Rename tables
     */
  }, {
    key: "renameTables",
    value: function () {
      var _renameTables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
            case "end":
              return _context7.stop();
          }
        }, _callee6);
      }));
      function renameTables() {
        return _renameTables.apply(this, arguments);
      }
      return renameTables;
    }()
    /**
     * Renames columns.
     * Works if only one column per table was changed.
     * Changes only column name. If something besides name was changed, these changes will be ignored.
     */
  }, {
    key: "renameColumns",
    value: function () {
      var _renameColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this4 = this;
        var _iterator2, _step2, _loop2, _ret2;
        return _regeneratorRuntime().wrap(function _callee7$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _iterator2 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context9.prev = 1;
              _loop2 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop2() {
                var metadata, table, renamedMetadataColumns, renamedTableColumns, renamedColumn;
                return _regeneratorRuntime().wrap(function _loop2$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      metadata = _step2.value;
                      table = _this4.queryRunner.loadedTables.find(function (table) {
                        return _this4.getTablePath(table) === _this4.getTablePath(metadata);
                      });
                      if (table) {
                        _context8.next = 4;
                        break;
                      }
                      return _context8.abrupt("return", "continue");
                    case 4:
                      if (!(metadata.columns.length !== table.columns.length)) {
                        _context8.next = 6;
                        break;
                      }
                      return _context8.abrupt("return", "continue");
                    case 6:
                      renamedMetadataColumns = metadata.columns.filter(function (c) {
                        return !c.isVirtualProperty;
                      }).filter(function (column) {
                        return !table.columns.find(function (tableColumn) {
                          return tableColumn.name === column.databaseName && tableColumn.type === _this4.connection.driver.normalizeType(column) && tableColumn.isNullable === column.isNullable && tableColumn.isUnique === _this4.connection.driver.normalizeIsUnique(column);
                        });
                      });
                      if (!(renamedMetadataColumns.length === 0 || renamedMetadataColumns.length > 1)) {
                        _context8.next = 9;
                        break;
                      }
                      return _context8.abrupt("return", "continue");
                    case 9:
                      renamedTableColumns = table.columns.filter(function (tableColumn) {
                        return !metadata.columns.find(function (column) {
                          return !column.isVirtualProperty && column.databaseName === tableColumn.name && _this4.connection.driver.normalizeType(column) === tableColumn.type && column.isNullable === tableColumn.isNullable && _this4.connection.driver.normalizeIsUnique(column) === tableColumn.isUnique;
                        });
                      });
                      if (!(renamedTableColumns.length === 0 || renamedTableColumns.length > 1)) {
                        _context8.next = 12;
                        break;
                      }
                      return _context8.abrupt("return", "continue");
                    case 12:
                      renamedColumn = renamedTableColumns[0].clone();
                      renamedColumn.name = renamedMetadataColumns[0].databaseName;
                      _this4.connection.logger.logSchemaBuild("renaming column \"".concat(renamedTableColumns[0].name, "\" in to \"").concat(renamedColumn.name, "\""));
                      _context8.next = 17;
                      return _this4.queryRunner.renameColumn(table, renamedTableColumns[0], renamedColumn);
                    case 17:
                    case "end":
                      return _context8.stop();
                  }
                }, _loop2);
              });
              _iterator2.s();
            case 4:
              if ((_step2 = _iterator2.n()).done) {
                _context9.next = 11;
                break;
              }
              return _context9.delegateYield(_loop2(), "t0", 6);
            case 6:
              _ret2 = _context9.t0;
              if (!(_ret2 === "continue")) {
                _context9.next = 9;
                break;
              }
              return _context9.abrupt("continue", 9);
            case 9:
              _context9.next = 4;
              break;
            case 11:
              _context9.next = 16;
              break;
            case 13:
              _context9.prev = 13;
              _context9.t1 = _context9["catch"](1);
              _iterator2.e(_context9.t1);
            case 16:
              _context9.prev = 16;
              _iterator2.f();
              return _context9.finish(16);
            case 19:
            case "end":
              return _context9.stop();
          }
        }, _callee7, this, [[1, 13, 16, 19]]);
      }));
      function renameColumns() {
        return _renameColumns.apply(this, arguments);
      }
      return renameColumns;
    }()
  }, {
    key: "dropOldIndices",
    value: function () {
      var _dropOldIndices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this5 = this;
        var _iterator3, _step3, _loop4, _ret4, postgresQueryRunner, _iterator4, _step4, _loop3, _ret3;
        return _regeneratorRuntime().wrap(function _callee10$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _iterator3 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context14.prev = 1;
              _loop4 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop4() {
                var metadata, table, dropQueries;
                return _regeneratorRuntime().wrap(function _loop4$(_context13) {
                  while (1) switch (_context13.prev = _context13.next) {
                    case 0:
                      metadata = _step3.value;
                      table = _this5.queryRunner.loadedTables.find(function (table) {
                        return _this5.getTablePath(table) === _this5.getTablePath(metadata);
                      });
                      if (table) {
                        _context13.next = 4;
                        break;
                      }
                      return _context13.abrupt("return", "continue");
                    case 4:
                      dropQueries = table.indices.filter(function (tableIndex) {
                        var indexMetadata = metadata.indices.find(function (index) {
                          return index.name === tableIndex.name;
                        });
                        if (indexMetadata) {
                          if (indexMetadata.synchronize === false) return false;
                          if (indexMetadata.isUnique !== tableIndex.isUnique) return true;
                          if (indexMetadata.isSpatial !== tableIndex.isSpatial) return true;
                          if (_this5.connection.driver.isFullTextColumnTypeSupported() && indexMetadata.isFulltext !== tableIndex.isFulltext) return true;
                          if (indexMetadata.columns.length !== tableIndex.columnNames.length) return true;
                          return !indexMetadata.columns.every(function (column) {
                            return tableIndex.columnNames.indexOf(column.databaseName) !== -1;
                          });
                        }
                        return true;
                      }).map( /*#__PURE__*/function () {
                        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(tableIndex) {
                          return _regeneratorRuntime().wrap(function _callee9$(_context12) {
                            while (1) switch (_context12.prev = _context12.next) {
                              case 0:
                                _this5.connection.logger.logSchemaBuild("dropping an index: \"".concat(tableIndex.name, "\" from table ").concat(table.name));
                                _context12.next = 3;
                                return _this5.queryRunner.dropIndex(table, tableIndex);
                              case 3:
                              case "end":
                                return _context12.stop();
                            }
                          }, _callee9);
                        }));
                        return function (_x3) {
                          return _ref2.apply(this, arguments);
                        };
                      }());
                      _context13.next = 7;
                      return Promise.all(dropQueries);
                    case 7:
                    case "end":
                      return _context13.stop();
                  }
                }, _loop4);
              });
              _iterator3.s();
            case 4:
              if ((_step3 = _iterator3.n()).done) {
                _context14.next = 11;
                break;
              }
              return _context14.delegateYield(_loop4(), "t0", 6);
            case 6:
              _ret4 = _context14.t0;
              if (!(_ret4 === "continue")) {
                _context14.next = 9;
                break;
              }
              return _context14.abrupt("continue", 9);
            case 9:
              _context14.next = 4;
              break;
            case 11:
              _context14.next = 16;
              break;
            case 13:
              _context14.prev = 13;
              _context14.t1 = _context14["catch"](1);
              _iterator3.e(_context14.t1);
            case 16:
              _context14.prev = 16;
              _iterator3.f();
              return _context14.finish(16);
            case 19:
              if (!(this.connection.options.type === "postgres")) {
                _context14.next = 40;
                break;
              }
              postgresQueryRunner = this.queryRunner;
              _iterator4 = _createForOfIteratorHelper(this.viewEntityToSyncMetadatas);
              _context14.prev = 22;
              _loop3 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop3() {
                var metadata, view, dropQueries;
                return _regeneratorRuntime().wrap(function _loop3$(_context11) {
                  while (1) switch (_context11.prev = _context11.next) {
                    case 0:
                      metadata = _step4.value;
                      view = _this5.queryRunner.loadedViews.find(function (view) {
                        return _this5.getTablePath(view) === _this5.getTablePath(metadata);
                      });
                      if (view) {
                        _context11.next = 4;
                        break;
                      }
                      return _context11.abrupt("return", "continue");
                    case 4:
                      dropQueries = view.indices.filter(function (tableIndex) {
                        var indexMetadata = metadata.indices.find(function (index) {
                          return index.name === tableIndex.name;
                        });
                        if (indexMetadata) {
                          if (indexMetadata.synchronize === false) return false;
                          if (indexMetadata.isUnique !== tableIndex.isUnique) return true;
                          if (indexMetadata.isSpatial !== tableIndex.isSpatial) return true;
                          if (_this5.connection.driver.isFullTextColumnTypeSupported() && indexMetadata.isFulltext !== tableIndex.isFulltext) return true;
                          if (indexMetadata.columns.length !== tableIndex.columnNames.length) return true;
                          return !indexMetadata.columns.every(function (column) {
                            return tableIndex.columnNames.indexOf(column.databaseName) !== -1;
                          });
                        }
                        return true;
                      }).map( /*#__PURE__*/function () {
                        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(tableIndex) {
                          return _regeneratorRuntime().wrap(function _callee8$(_context10) {
                            while (1) switch (_context10.prev = _context10.next) {
                              case 0:
                                _this5.connection.logger.logSchemaBuild("dropping an index: \"".concat(tableIndex.name, "\" from view ").concat(view.name));
                                _context10.next = 3;
                                return postgresQueryRunner.dropViewIndex(view, tableIndex);
                              case 3:
                              case "end":
                                return _context10.stop();
                            }
                          }, _callee8);
                        }));
                        return function (_x2) {
                          return _ref.apply(this, arguments);
                        };
                      }());
                      _context11.next = 7;
                      return Promise.all(dropQueries);
                    case 7:
                    case "end":
                      return _context11.stop();
                  }
                }, _loop3);
              });
              _iterator4.s();
            case 25:
              if ((_step4 = _iterator4.n()).done) {
                _context14.next = 32;
                break;
              }
              return _context14.delegateYield(_loop3(), "t2", 27);
            case 27:
              _ret3 = _context14.t2;
              if (!(_ret3 === "continue")) {
                _context14.next = 30;
                break;
              }
              return _context14.abrupt("continue", 30);
            case 30:
              _context14.next = 25;
              break;
            case 32:
              _context14.next = 37;
              break;
            case 34:
              _context14.prev = 34;
              _context14.t3 = _context14["catch"](22);
              _iterator4.e(_context14.t3);
            case 37:
              _context14.prev = 37;
              _iterator4.f();
              return _context14.finish(37);
            case 40:
            case "end":
              return _context14.stop();
          }
        }, _callee10, this, [[1, 13, 16, 19], [22, 34, 37, 40]]);
      }));
      function dropOldIndices() {
        return _dropOldIndices.apply(this, arguments);
      }
      return dropOldIndices;
    }()
  }, {
    key: "dropOldChecks",
    value: function () {
      var _dropOldChecks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this6 = this;
        var _iterator5, _step5, _loop5, _ret5;
        return _regeneratorRuntime().wrap(function _callee11$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (!(DriverUtils.isMySQLFamily(this.connection.driver) || this.connection.driver.options.type === "aurora-mysql")) {
                _context16.next = 2;
                break;
              }
              return _context16.abrupt("return");
            case 2:
              _iterator5 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context16.prev = 3;
              _loop5 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop5() {
                var metadata, table, oldChecks;
                return _regeneratorRuntime().wrap(function _loop5$(_context15) {
                  while (1) switch (_context15.prev = _context15.next) {
                    case 0:
                      metadata = _step5.value;
                      table = _this6.queryRunner.loadedTables.find(function (table) {
                        return _this6.getTablePath(table) === _this6.getTablePath(metadata);
                      });
                      if (table) {
                        _context15.next = 4;
                        break;
                      }
                      return _context15.abrupt("return", "continue");
                    case 4:
                      oldChecks = table.checks.filter(function (tableCheck) {
                        return !metadata.checks.find(function (checkMetadata) {
                          return checkMetadata.name === tableCheck.name;
                        });
                      });
                      if (!(oldChecks.length === 0)) {
                        _context15.next = 7;
                        break;
                      }
                      return _context15.abrupt("return", "continue");
                    case 7:
                      _this6.connection.logger.logSchemaBuild("dropping old check constraint: ".concat(oldChecks.map(function (check) {
                        return "\"".concat(check.name, "\"");
                      }).join(", "), " from table \"").concat(table.name, "\""));
                      _context15.next = 10;
                      return _this6.queryRunner.dropCheckConstraints(table, oldChecks);
                    case 10:
                    case "end":
                      return _context15.stop();
                  }
                }, _loop5);
              });
              _iterator5.s();
            case 6:
              if ((_step5 = _iterator5.n()).done) {
                _context16.next = 13;
                break;
              }
              return _context16.delegateYield(_loop5(), "t0", 8);
            case 8:
              _ret5 = _context16.t0;
              if (!(_ret5 === "continue")) {
                _context16.next = 11;
                break;
              }
              return _context16.abrupt("continue", 11);
            case 11:
              _context16.next = 6;
              break;
            case 13:
              _context16.next = 18;
              break;
            case 15:
              _context16.prev = 15;
              _context16.t1 = _context16["catch"](3);
              _iterator5.e(_context16.t1);
            case 18:
              _context16.prev = 18;
              _iterator5.f();
              return _context16.finish(18);
            case 21:
            case "end":
              return _context16.stop();
          }
        }, _callee11, this, [[3, 15, 18, 21]]);
      }));
      function dropOldChecks() {
        return _dropOldChecks.apply(this, arguments);
      }
      return dropOldChecks;
    }()
  }, {
    key: "dropCompositeUniqueConstraints",
    value: function () {
      var _dropCompositeUniqueConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this7 = this;
        var _iterator6, _step6, _loop6, _ret6;
        return _regeneratorRuntime().wrap(function _callee12$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _iterator6 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context18.prev = 1;
              _loop6 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop6() {
                var metadata, table, compositeUniques;
                return _regeneratorRuntime().wrap(function _loop6$(_context17) {
                  while (1) switch (_context17.prev = _context17.next) {
                    case 0:
                      metadata = _step6.value;
                      table = _this7.queryRunner.loadedTables.find(function (table) {
                        return _this7.getTablePath(table) === _this7.getTablePath(metadata);
                      });
                      if (table) {
                        _context17.next = 4;
                        break;
                      }
                      return _context17.abrupt("return", "continue");
                    case 4:
                      compositeUniques = table.uniques.filter(function (tableUnique) {
                        return tableUnique.columnNames.length > 1 && !metadata.uniques.find(function (uniqueMetadata) {
                          return uniqueMetadata.name === tableUnique.name;
                        });
                      });
                      if (!(compositeUniques.length === 0)) {
                        _context17.next = 7;
                        break;
                      }
                      return _context17.abrupt("return", "continue");
                    case 7:
                      _this7.connection.logger.logSchemaBuild("dropping old unique constraint: ".concat(compositeUniques.map(function (unique) {
                        return "\"".concat(unique.name, "\"");
                      }).join(", "), " from table \"").concat(table.name, "\""));
                      _context17.next = 10;
                      return _this7.queryRunner.dropUniqueConstraints(table, compositeUniques);
                    case 10:
                    case "end":
                      return _context17.stop();
                  }
                }, _loop6);
              });
              _iterator6.s();
            case 4:
              if ((_step6 = _iterator6.n()).done) {
                _context18.next = 11;
                break;
              }
              return _context18.delegateYield(_loop6(), "t0", 6);
            case 6:
              _ret6 = _context18.t0;
              if (!(_ret6 === "continue")) {
                _context18.next = 9;
                break;
              }
              return _context18.abrupt("continue", 9);
            case 9:
              _context18.next = 4;
              break;
            case 11:
              _context18.next = 16;
              break;
            case 13:
              _context18.prev = 13;
              _context18.t1 = _context18["catch"](1);
              _iterator6.e(_context18.t1);
            case 16:
              _context18.prev = 16;
              _iterator6.f();
              return _context18.finish(16);
            case 19:
            case "end":
              return _context18.stop();
          }
        }, _callee12, this, [[1, 13, 16, 19]]);
      }));
      function dropCompositeUniqueConstraints() {
        return _dropCompositeUniqueConstraints.apply(this, arguments);
      }
      return dropCompositeUniqueConstraints;
    }()
  }, {
    key: "dropOldExclusions",
    value: function () {
      var _dropOldExclusions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this8 = this;
        var _iterator7, _step7, _loop7, _ret7;
        return _regeneratorRuntime().wrap(function _callee13$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (this.connection.driver.options.type === "postgres") {
                _context20.next = 2;
                break;
              }
              return _context20.abrupt("return");
            case 2:
              _iterator7 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context20.prev = 3;
              _loop7 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop7() {
                var metadata, table, oldExclusions;
                return _regeneratorRuntime().wrap(function _loop7$(_context19) {
                  while (1) switch (_context19.prev = _context19.next) {
                    case 0:
                      metadata = _step7.value;
                      table = _this8.queryRunner.loadedTables.find(function (table) {
                        return _this8.getTablePath(table) === _this8.getTablePath(metadata);
                      });
                      if (table) {
                        _context19.next = 4;
                        break;
                      }
                      return _context19.abrupt("return", "continue");
                    case 4:
                      oldExclusions = table.exclusions.filter(function (tableExclusion) {
                        return !metadata.exclusions.find(function (exclusionMetadata) {
                          return exclusionMetadata.name === tableExclusion.name;
                        });
                      });
                      if (!(oldExclusions.length === 0)) {
                        _context19.next = 7;
                        break;
                      }
                      return _context19.abrupt("return", "continue");
                    case 7:
                      _this8.connection.logger.logSchemaBuild("dropping old exclusion constraint: ".concat(oldExclusions.map(function (exclusion) {
                        return "\"".concat(exclusion.name, "\"");
                      }).join(", "), " from table \"").concat(table.name, "\""));
                      _context19.next = 10;
                      return _this8.queryRunner.dropExclusionConstraints(table, oldExclusions);
                    case 10:
                    case "end":
                      return _context19.stop();
                  }
                }, _loop7);
              });
              _iterator7.s();
            case 6:
              if ((_step7 = _iterator7.n()).done) {
                _context20.next = 13;
                break;
              }
              return _context20.delegateYield(_loop7(), "t0", 8);
            case 8:
              _ret7 = _context20.t0;
              if (!(_ret7 === "continue")) {
                _context20.next = 11;
                break;
              }
              return _context20.abrupt("continue", 11);
            case 11:
              _context20.next = 6;
              break;
            case 13:
              _context20.next = 18;
              break;
            case 15:
              _context20.prev = 15;
              _context20.t1 = _context20["catch"](3);
              _iterator7.e(_context20.t1);
            case 18:
              _context20.prev = 18;
              _iterator7.f();
              return _context20.finish(18);
            case 21:
            case "end":
              return _context20.stop();
          }
        }, _callee13, this, [[3, 15, 18, 21]]);
      }));
      function dropOldExclusions() {
        return _dropOldExclusions.apply(this, arguments);
      }
      return dropOldExclusions;
    }()
    /**
     * Creates tables that do not exist in the database yet.
     * New tables are created without foreign and primary keys.
     * Primary key only can be created in conclusion with auto generated column.
     */
  }, {
    key: "createNewTables",
    value: function () {
      var _createNewTables = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this9 = this;
        var _iterator8, _step8, _loop8, _ret8;
        return _regeneratorRuntime().wrap(function _callee14$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _iterator8 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context22.prev = 1;
              _loop8 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop8() {
                var metadata, existTable, table;
                return _regeneratorRuntime().wrap(function _loop8$(_context21) {
                  while (1) switch (_context21.prev = _context21.next) {
                    case 0:
                      metadata = _step8.value;
                      // check if table does not exist yet
                      existTable = _this9.queryRunner.loadedTables.find(function (table) {
                        return _this9.getTablePath(table) === _this9.getTablePath(metadata);
                      });
                      if (!existTable) {
                        _context21.next = 4;
                        break;
                      }
                      return _context21.abrupt("return", "continue");
                    case 4:
                      _this9.connection.logger.logSchemaBuild("creating a new table: ".concat(_this9.getTablePath(metadata)));
                      // create a new table and sync it in the database
                      table = Table.create(metadata, _this9.connection.driver);
                      _context21.next = 8;
                      return _this9.queryRunner.createTable(table, false, false);
                    case 8:
                      _this9.queryRunner.loadedTables.push(table);
                    case 9:
                    case "end":
                      return _context21.stop();
                  }
                }, _loop8);
              });
              _iterator8.s();
            case 4:
              if ((_step8 = _iterator8.n()).done) {
                _context22.next = 11;
                break;
              }
              return _context22.delegateYield(_loop8(), "t0", 6);
            case 6:
              _ret8 = _context22.t0;
              if (!(_ret8 === "continue")) {
                _context22.next = 9;
                break;
              }
              return _context22.abrupt("continue", 9);
            case 9:
              _context22.next = 4;
              break;
            case 11:
              _context22.next = 16;
              break;
            case 13:
              _context22.prev = 13;
              _context22.t1 = _context22["catch"](1);
              _iterator8.e(_context22.t1);
            case 16:
              _context22.prev = 16;
              _iterator8.f();
              return _context22.finish(16);
            case 19:
            case "end":
              return _context22.stop();
          }
        }, _callee14, this, [[1, 13, 16, 19]]);
      }));
      function createNewTables() {
        return _createNewTables.apply(this, arguments);
      }
      return createNewTables;
    }()
  }, {
    key: "createViews",
    value: function () {
      var _createViews = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var _this10 = this;
        var _iterator9, _step9, _loop9, _ret9;
        return _regeneratorRuntime().wrap(function _callee15$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _iterator9 = _createForOfIteratorHelper(this.viewEntityToSyncMetadatas);
              _context24.prev = 1;
              _loop9 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop9() {
                var metadata, existView, view;
                return _regeneratorRuntime().wrap(function _loop9$(_context23) {
                  while (1) switch (_context23.prev = _context23.next) {
                    case 0:
                      metadata = _step9.value;
                      // check if view does not exist yet
                      existView = _this10.queryRunner.loadedViews.find(function (view) {
                        var viewExpression = typeof view.expression === "string" ? view.expression.trim() : view.expression(_this10.connection).getQuery();
                        var metadataExpression = typeof metadata.expression === "string" ? metadata.expression.trim() : metadata.expression(_this10.connection).getQuery();
                        return _this10.getTablePath(view) === _this10.getTablePath(metadata) && viewExpression === metadataExpression;
                      });
                      if (!existView) {
                        _context23.next = 4;
                        break;
                      }
                      return _context23.abrupt("return", "continue");
                    case 4:
                      _this10.connection.logger.logSchemaBuild("creating a new view: ".concat(_this10.getTablePath(metadata)));
                      // create a new view and sync it in the database
                      view = View.create(metadata, _this10.connection.driver);
                      _context23.next = 8;
                      return _this10.queryRunner.createView(view, true);
                    case 8:
                      _this10.queryRunner.loadedViews.push(view);
                    case 9:
                    case "end":
                      return _context23.stop();
                  }
                }, _loop9);
              });
              _iterator9.s();
            case 4:
              if ((_step9 = _iterator9.n()).done) {
                _context24.next = 11;
                break;
              }
              return _context24.delegateYield(_loop9(), "t0", 6);
            case 6:
              _ret9 = _context24.t0;
              if (!(_ret9 === "continue")) {
                _context24.next = 9;
                break;
              }
              return _context24.abrupt("continue", 9);
            case 9:
              _context24.next = 4;
              break;
            case 11:
              _context24.next = 16;
              break;
            case 13:
              _context24.prev = 13;
              _context24.t1 = _context24["catch"](1);
              _iterator9.e(_context24.t1);
            case 16:
              _context24.prev = 16;
              _iterator9.f();
              return _context24.finish(16);
            case 19:
            case "end":
              return _context24.stop();
          }
        }, _callee15, this, [[1, 13, 16, 19]]);
      }));
      function createViews() {
        return _createViews.apply(this, arguments);
      }
      return createViews;
    }()
  }, {
    key: "dropOldViews",
    value: function () {
      var _dropOldViews = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var _this11 = this;
        var droppedViews, viewEntityToSyncMetadatas, viewToMetadata, _iterator10, _step10, _loop10, _iterator11, _step11, view, viewMetadata, viewExpression, metadataExpression, viewDependencyChain, droppedViewsWithDependencies, _iterator13, _step13, _view;
        return _regeneratorRuntime().wrap(function _callee16$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              droppedViews = [];
              viewEntityToSyncMetadatas = this.viewEntityToSyncMetadatas; // BuIld lookup cache for finding views metadata
              viewToMetadata = new Map();
              _iterator10 = _createForOfIteratorHelper(this.queryRunner.loadedViews);
              _context26.prev = 4;
              _loop10 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop10() {
                var view, viewMetadata;
                return _regeneratorRuntime().wrap(function _loop10$(_context25) {
                  while (1) switch (_context25.prev = _context25.next) {
                    case 0:
                      view = _step10.value;
                      viewMetadata = viewEntityToSyncMetadatas.find(function (metadata) {
                        return _this11.getTablePath(view) === _this11.getTablePath(metadata);
                      });
                      if (viewMetadata) {
                        viewToMetadata.set(view, viewMetadata);
                      }
                    case 3:
                    case "end":
                      return _context25.stop();
                  }
                }, _loop10);
              });
              _iterator10.s();
            case 7:
              if ((_step10 = _iterator10.n()).done) {
                _context26.next = 11;
                break;
              }
              return _context26.delegateYield(_loop10(), "t0", 9);
            case 9:
              _context26.next = 7;
              break;
            case 11:
              _context26.next = 16;
              break;
            case 13:
              _context26.prev = 13;
              _context26.t1 = _context26["catch"](4);
              _iterator10.e(_context26.t1);
            case 16:
              _context26.prev = 16;
              _iterator10.f();
              return _context26.finish(16);
            case 19:
              // Gather all changed view, that need a drop
              _iterator11 = _createForOfIteratorHelper(this.queryRunner.loadedViews);
              _context26.prev = 20;
              _iterator11.s();
            case 22:
              if ((_step11 = _iterator11.n()).done) {
                _context26.next = 35;
                break;
              }
              view = _step11.value;
              viewMetadata = viewToMetadata.get(view);
              if (viewMetadata) {
                _context26.next = 27;
                break;
              }
              return _context26.abrupt("continue", 33);
            case 27:
              viewExpression = typeof view.expression === "string" ? view.expression.trim() : view.expression(this.connection).getQuery();
              metadataExpression = typeof viewMetadata.expression === "string" ? viewMetadata.expression.trim() : viewMetadata.expression(this.connection).getQuery();
              if (!(viewExpression === metadataExpression)) {
                _context26.next = 31;
                break;
              }
              return _context26.abrupt("continue", 33);
            case 31:
              this.connection.logger.logSchemaBuild("dropping an old view: ".concat(view.name));
              // Collect view to be dropped
              droppedViews.push(view);
            case 33:
              _context26.next = 22;
              break;
            case 35:
              _context26.next = 40;
              break;
            case 37:
              _context26.prev = 37;
              _context26.t2 = _context26["catch"](20);
              _iterator11.e(_context26.t2);
            case 40:
              _context26.prev = 40;
              _iterator11.f();
              return _context26.finish(40);
            case 43:
              // Helper function that for a given view, will recursively return list of the view and all views that depend on it
              viewDependencyChain = function viewDependencyChain(view) {
                // Get the view metadata
                var viewMetadata = viewToMetadata.get(view);
                var viewWithDependencies = [view];
                // If no metadata is known for the view, simply return the view itself
                if (!viewMetadata) {
                  return viewWithDependencies;
                }
                // Iterate over all known views
                var _iterator12 = _createForOfIteratorHelper(viewToMetadata.entries()),
                  _step12;
                try {
                  for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                    var _step12$value = _slicedToArray(_step12.value, 2),
                      currentView = _step12$value[0],
                      currentMetadata = _step12$value[1];
                    // Ignore self reference
                    if (currentView === view) {
                      continue;
                    }
                    // If the currently iterated view depends on the passed in view
                    if (currentMetadata.dependsOn && (currentMetadata.dependsOn.has(viewMetadata.target) || currentMetadata.dependsOn.has(viewMetadata.name))) {
                      // Recursively add currently iterate view and its dependents
                      viewWithDependencies = viewWithDependencies.concat(viewDependencyChain(currentView));
                    }
                  }
                  // Return all collected views
                } catch (err) {
                  _iterator12.e(err);
                } finally {
                  _iterator12.f();
                }
                return viewWithDependencies;
              }; // Collect final list of views to be dropped in a Set so there are no duplicates
              droppedViewsWithDependencies = new Set(
              // Collect all dropped views, and their dependencies
              droppedViews.map(function (view) {
                return viewDependencyChain(view);
              })
              // Flattened to single Array ( can be replaced with flatMap, once supported)
              .reduce(function (all, segment) {
                return all.concat(segment);
              }, [])
              // Sort the views to be dropped in creation order
              .sort(function (a, b) {
                return ViewUtils.viewMetadataCmp(viewToMetadata.get(a), viewToMetadata.get(b));
              })
              // reverse order to get drop order
              .reverse()); // Finally emit all drop views
              _iterator13 = _createForOfIteratorHelper(droppedViewsWithDependencies);
              _context26.prev = 46;
              _iterator13.s();
            case 48:
              if ((_step13 = _iterator13.n()).done) {
                _context26.next = 54;
                break;
              }
              _view = _step13.value;
              _context26.next = 52;
              return this.queryRunner.dropView(_view);
            case 52:
              _context26.next = 48;
              break;
            case 54:
              _context26.next = 59;
              break;
            case 56:
              _context26.prev = 56;
              _context26.t3 = _context26["catch"](46);
              _iterator13.e(_context26.t3);
            case 59:
              _context26.prev = 59;
              _iterator13.f();
              return _context26.finish(59);
            case 62:
              this.queryRunner.loadedViews = this.queryRunner.loadedViews.filter(function (view) {
                return !droppedViewsWithDependencies.has(view);
              });
            case 63:
            case "end":
              return _context26.stop();
          }
        }, _callee16, this, [[4, 13, 16, 19], [20, 37, 40, 43], [46, 56, 59, 62]]);
      }));
      function dropOldViews() {
        return _dropOldViews.apply(this, arguments);
      }
      return dropOldViews;
    }()
    /**
     * Drops all columns that exist in the table, but does not exist in the metadata (left old).
     * We drop their keys too, since it should be safe.
     */
  }, {
    key: "dropRemovedColumns",
    value: function () {
      var _dropRemovedColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var _this12 = this;
        var _iterator14, _step14, _loop11, _ret10;
        return _regeneratorRuntime().wrap(function _callee17$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _iterator14 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context28.prev = 1;
              _loop11 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop11() {
                var metadata, table, droppedTableColumns;
                return _regeneratorRuntime().wrap(function _loop11$(_context27) {
                  while (1) switch (_context27.prev = _context27.next) {
                    case 0:
                      metadata = _step14.value;
                      table = _this12.queryRunner.loadedTables.find(function (table) {
                        return _this12.getTablePath(table) === _this12.getTablePath(metadata);
                      });
                      if (table) {
                        _context27.next = 4;
                        break;
                      }
                      return _context27.abrupt("return", "continue");
                    case 4:
                      // find columns that exist in the database but does not exist in the metadata
                      droppedTableColumns = table.columns.filter(function (tableColumn) {
                        return !metadata.columns.find(function (columnMetadata) {
                          return columnMetadata.isVirtualProperty || columnMetadata.databaseName === tableColumn.name;
                        });
                      });
                      if (!(droppedTableColumns.length === 0)) {
                        _context27.next = 7;
                        break;
                      }
                      return _context27.abrupt("return", "continue");
                    case 7:
                      _this12.connection.logger.logSchemaBuild("columns dropped in ".concat(table.name, ": ") + droppedTableColumns.map(function (column) {
                        return column.name;
                      }).join(", "));
                      // drop columns from the database
                      _context27.next = 10;
                      return _this12.queryRunner.dropColumns(table, droppedTableColumns);
                    case 10:
                    case "end":
                      return _context27.stop();
                  }
                }, _loop11);
              });
              _iterator14.s();
            case 4:
              if ((_step14 = _iterator14.n()).done) {
                _context28.next = 11;
                break;
              }
              return _context28.delegateYield(_loop11(), "t0", 6);
            case 6:
              _ret10 = _context28.t0;
              if (!(_ret10 === "continue")) {
                _context28.next = 9;
                break;
              }
              return _context28.abrupt("continue", 9);
            case 9:
              _context28.next = 4;
              break;
            case 11:
              _context28.next = 16;
              break;
            case 13:
              _context28.prev = 13;
              _context28.t1 = _context28["catch"](1);
              _iterator14.e(_context28.t1);
            case 16:
              _context28.prev = 16;
              _iterator14.f();
              return _context28.finish(16);
            case 19:
            case "end":
              return _context28.stop();
          }
        }, _callee17, this, [[1, 13, 16, 19]]);
      }));
      function dropRemovedColumns() {
        return _dropRemovedColumns.apply(this, arguments);
      }
      return dropRemovedColumns;
    }()
    /**
     * Adds columns from metadata which does not exist in the table.
     * Columns are created without keys.
     */
  }, {
    key: "addNewColumns",
    value: function () {
      var _addNewColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var _this13 = this;
        var _iterator15, _step15, _loop12, _ret11;
        return _regeneratorRuntime().wrap(function _callee18$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _iterator15 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context30.prev = 1;
              _loop12 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop12() {
                var metadata, table, newColumnMetadatas, newTableColumnOptions, newTableColumns;
                return _regeneratorRuntime().wrap(function _loop12$(_context29) {
                  while (1) switch (_context29.prev = _context29.next) {
                    case 0:
                      metadata = _step15.value;
                      table = _this13.queryRunner.loadedTables.find(function (table) {
                        return _this13.getTablePath(table) === _this13.getTablePath(metadata);
                      });
                      if (table) {
                        _context29.next = 4;
                        break;
                      }
                      return _context29.abrupt("return", "continue");
                    case 4:
                      // find which columns are new
                      newColumnMetadatas = metadata.columns.filter(function (columnMetadata) {
                        return !columnMetadata.isVirtualProperty && !table.columns.find(function (tableColumn) {
                          return tableColumn.name === columnMetadata.databaseName;
                        });
                      });
                      if (!(newColumnMetadatas.length === 0)) {
                        _context29.next = 7;
                        break;
                      }
                      return _context29.abrupt("return", "continue");
                    case 7:
                      // create columns in the database
                      newTableColumnOptions = _this13.metadataColumnsToTableColumnOptions(newColumnMetadatas);
                      newTableColumns = newTableColumnOptions.map(function (option) {
                        return new TableColumn(option);
                      });
                      if (!(newTableColumns.length === 0)) {
                        _context29.next = 11;
                        break;
                      }
                      return _context29.abrupt("return", "continue");
                    case 11:
                      _this13.connection.logger.logSchemaBuild("new columns added: " + newColumnMetadatas.map(function (column) {
                        return column.databaseName;
                      }).join(", "));
                      _context29.next = 14;
                      return _this13.queryRunner.addColumns(table, newTableColumns);
                    case 14:
                    case "end":
                      return _context29.stop();
                  }
                }, _loop12);
              });
              _iterator15.s();
            case 4:
              if ((_step15 = _iterator15.n()).done) {
                _context30.next = 11;
                break;
              }
              return _context30.delegateYield(_loop12(), "t0", 6);
            case 6:
              _ret11 = _context30.t0;
              if (!(_ret11 === "continue")) {
                _context30.next = 9;
                break;
              }
              return _context30.abrupt("continue", 9);
            case 9:
              _context30.next = 4;
              break;
            case 11:
              _context30.next = 16;
              break;
            case 13:
              _context30.prev = 13;
              _context30.t1 = _context30["catch"](1);
              _iterator15.e(_context30.t1);
            case 16:
              _context30.prev = 16;
              _iterator15.f();
              return _context30.finish(16);
            case 19:
            case "end":
              return _context30.stop();
          }
        }, _callee18, this, [[1, 13, 16, 19]]);
      }));
      function addNewColumns() {
        return _addNewColumns.apply(this, arguments);
      }
      return addNewColumns;
    }()
    /**
     * Updates composite primary keys.
     */
  }, {
    key: "updatePrimaryKeys",
    value: function () {
      var _updatePrimaryKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var _this14 = this;
        var _iterator16, _step16, _loop13, _ret12;
        return _regeneratorRuntime().wrap(function _callee19$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _iterator16 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context32.prev = 1;
              _loop13 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop13() {
                var metadata, table, primaryMetadataColumns, primaryTableColumns, changedPrimaryColumns;
                return _regeneratorRuntime().wrap(function _loop13$(_context31) {
                  while (1) switch (_context31.prev = _context31.next) {
                    case 0:
                      metadata = _step16.value;
                      table = _this14.queryRunner.loadedTables.find(function (table) {
                        return _this14.getTablePath(table) === _this14.getTablePath(metadata);
                      });
                      if (table) {
                        _context31.next = 4;
                        break;
                      }
                      return _context31.abrupt("return", "continue");
                    case 4:
                      primaryMetadataColumns = metadata.columns.filter(function (column) {
                        return column.isPrimary;
                      });
                      primaryTableColumns = table.columns.filter(function (column) {
                        return column.isPrimary;
                      });
                      if (!(primaryTableColumns.length !== primaryMetadataColumns.length && primaryMetadataColumns.length > 1)) {
                        _context31.next = 10;
                        break;
                      }
                      changedPrimaryColumns = primaryMetadataColumns.map(function (primaryMetadataColumn) {
                        return new TableColumn(TableUtils.createTableColumnOptions(primaryMetadataColumn, _this14.connection.driver));
                      });
                      _context31.next = 10;
                      return _this14.queryRunner.updatePrimaryKeys(table, changedPrimaryColumns);
                    case 10:
                    case "end":
                      return _context31.stop();
                  }
                }, _loop13);
              });
              _iterator16.s();
            case 4:
              if ((_step16 = _iterator16.n()).done) {
                _context32.next = 11;
                break;
              }
              return _context32.delegateYield(_loop13(), "t0", 6);
            case 6:
              _ret12 = _context32.t0;
              if (!(_ret12 === "continue")) {
                _context32.next = 9;
                break;
              }
              return _context32.abrupt("continue", 9);
            case 9:
              _context32.next = 4;
              break;
            case 11:
              _context32.next = 16;
              break;
            case 13:
              _context32.prev = 13;
              _context32.t1 = _context32["catch"](1);
              _iterator16.e(_context32.t1);
            case 16:
              _context32.prev = 16;
              _iterator16.f();
              return _context32.finish(16);
            case 19:
            case "end":
              return _context32.stop();
          }
        }, _callee19, this, [[1, 13, 16, 19]]);
      }));
      function updatePrimaryKeys() {
        return _updatePrimaryKeys.apply(this, arguments);
      }
      return updatePrimaryKeys;
    }()
    /**
     * Update all exist columns which metadata has changed.
     * Still don't create keys. Also we don't touch foreign keys of the changed columns.
     */
  }, {
    key: "updateExistColumns",
    value: function () {
      var _updateExistColumns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var _this15 = this;
        var _iterator17, _step17, _loop14, _ret13;
        return _regeneratorRuntime().wrap(function _callee20$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              _iterator17 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context34.prev = 1;
              _loop14 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop14() {
                var metadata, table, changedColumns, _iterator18, _step18, _changedColumn, _iterator19, _step19, _changedColumn2, _iterator20, _step20, changedColumn, newAndOldTableColumns;
                return _regeneratorRuntime().wrap(function _loop14$(_context33) {
                  while (1) switch (_context33.prev = _context33.next) {
                    case 0:
                      metadata = _step17.value;
                      table = _this15.queryRunner.loadedTables.find(function (table) {
                        return _this15.getTablePath(table) === _this15.getTablePath(metadata);
                      });
                      if (table) {
                        _context33.next = 4;
                        break;
                      }
                      return _context33.abrupt("return", "continue");
                    case 4:
                      changedColumns = _this15.connection.driver.findChangedColumns(table.columns, metadata.columns);
                      if (!(changedColumns.length === 0)) {
                        _context33.next = 7;
                        break;
                      }
                      return _context33.abrupt("return", "continue");
                    case 7:
                      // drop all foreign keys that point to this column
                      _iterator18 = _createForOfIteratorHelper(changedColumns);
                      _context33.prev = 8;
                      _iterator18.s();
                    case 10:
                      if ((_step18 = _iterator18.n()).done) {
                        _context33.next = 16;
                        break;
                      }
                      _changedColumn = _step18.value;
                      _context33.next = 14;
                      return _this15.dropColumnReferencedForeignKeys(_this15.getTablePath(metadata), _changedColumn.databaseName);
                    case 14:
                      _context33.next = 10;
                      break;
                    case 16:
                      _context33.next = 21;
                      break;
                    case 18:
                      _context33.prev = 18;
                      _context33.t0 = _context33["catch"](8);
                      _iterator18.e(_context33.t0);
                    case 21:
                      _context33.prev = 21;
                      _iterator18.f();
                      return _context33.finish(21);
                    case 24:
                      // drop all composite indices related to this column
                      _iterator19 = _createForOfIteratorHelper(changedColumns);
                      _context33.prev = 25;
                      _iterator19.s();
                    case 27:
                      if ((_step19 = _iterator19.n()).done) {
                        _context33.next = 33;
                        break;
                      }
                      _changedColumn2 = _step19.value;
                      _context33.next = 31;
                      return _this15.dropColumnCompositeIndices(_this15.getTablePath(metadata), _changedColumn2.databaseName);
                    case 31:
                      _context33.next = 27;
                      break;
                    case 33:
                      _context33.next = 38;
                      break;
                    case 35:
                      _context33.prev = 35;
                      _context33.t1 = _context33["catch"](25);
                      _iterator19.e(_context33.t1);
                    case 38:
                      _context33.prev = 38;
                      _iterator19.f();
                      return _context33.finish(38);
                    case 41:
                      if (DriverUtils.isMySQLFamily(_this15.connection.driver) || _this15.connection.driver.options.type === "aurora-mysql" || _this15.connection.driver.options.type === "spanner") {
                        _context33.next = 59;
                        break;
                      }
                      _iterator20 = _createForOfIteratorHelper(changedColumns);
                      _context33.prev = 43;
                      _iterator20.s();
                    case 45:
                      if ((_step20 = _iterator20.n()).done) {
                        _context33.next = 51;
                        break;
                      }
                      changedColumn = _step20.value;
                      _context33.next = 49;
                      return _this15.dropColumnCompositeUniques(_this15.getTablePath(metadata), changedColumn.databaseName);
                    case 49:
                      _context33.next = 45;
                      break;
                    case 51:
                      _context33.next = 56;
                      break;
                    case 53:
                      _context33.prev = 53;
                      _context33.t2 = _context33["catch"](43);
                      _iterator20.e(_context33.t2);
                    case 56:
                      _context33.prev = 56;
                      _iterator20.f();
                      return _context33.finish(56);
                    case 59:
                      // generate a map of new/old columns
                      newAndOldTableColumns = changedColumns.map(function (changedColumn) {
                        var oldTableColumn = table.columns.find(function (column) {
                          return column.name === changedColumn.databaseName;
                        });
                        var newTableColumnOptions = TableUtils.createTableColumnOptions(changedColumn, _this15.connection.driver);
                        var newTableColumn = new TableColumn(newTableColumnOptions);
                        return {
                          oldColumn: oldTableColumn,
                          newColumn: newTableColumn
                        };
                      });
                      if (!(newAndOldTableColumns.length === 0)) {
                        _context33.next = 62;
                        break;
                      }
                      return _context33.abrupt("return", "continue");
                    case 62:
                      _this15.connection.logger.logSchemaBuild("columns changed in \"".concat(table.name, "\". updating: ") + changedColumns.map(function (column) {
                        return column.databaseName;
                      }).join(", "));
                      _context33.next = 65;
                      return _this15.queryRunner.changeColumns(table, newAndOldTableColumns);
                    case 65:
                    case "end":
                      return _context33.stop();
                  }
                }, _loop14, null, [[8, 18, 21, 24], [25, 35, 38, 41], [43, 53, 56, 59]]);
              });
              _iterator17.s();
            case 4:
              if ((_step17 = _iterator17.n()).done) {
                _context34.next = 11;
                break;
              }
              return _context34.delegateYield(_loop14(), "t0", 6);
            case 6:
              _ret13 = _context34.t0;
              if (!(_ret13 === "continue")) {
                _context34.next = 9;
                break;
              }
              return _context34.abrupt("continue", 9);
            case 9:
              _context34.next = 4;
              break;
            case 11:
              _context34.next = 16;
              break;
            case 13:
              _context34.prev = 13;
              _context34.t1 = _context34["catch"](1);
              _iterator17.e(_context34.t1);
            case 16:
              _context34.prev = 16;
              _iterator17.f();
              return _context34.finish(16);
            case 19:
            case "end":
              return _context34.stop();
          }
        }, _callee20, this, [[1, 13, 16, 19]]);
      }));
      function updateExistColumns() {
        return _updateExistColumns.apply(this, arguments);
      }
      return updateExistColumns;
    }()
    /**
     * Creates composite indices which are missing in db yet.
     */
  }, {
    key: "createNewIndices",
    value: function () {
      var _createNewIndices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        var _this16 = this;
        var _iterator21, _step21, _loop15, _ret14;
        return _regeneratorRuntime().wrap(function _callee21$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              _iterator21 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context36.prev = 1;
              _loop15 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop15() {
                var metadata, table, newIndices;
                return _regeneratorRuntime().wrap(function _loop15$(_context35) {
                  while (1) switch (_context35.prev = _context35.next) {
                    case 0:
                      metadata = _step21.value;
                      table = _this16.queryRunner.loadedTables.find(function (table) {
                        return _this16.getTablePath(table) === _this16.getTablePath(metadata);
                      });
                      if (table) {
                        _context35.next = 4;
                        break;
                      }
                      return _context35.abrupt("return", "continue");
                    case 4:
                      newIndices = metadata.indices.filter(function (indexMetadata) {
                        return !table.indices.find(function (tableIndex) {
                          return tableIndex.name === indexMetadata.name;
                        }) && indexMetadata.synchronize === true;
                      }).map(function (indexMetadata) {
                        return TableIndex.create(indexMetadata);
                      });
                      if (!(newIndices.length === 0)) {
                        _context35.next = 7;
                        break;
                      }
                      return _context35.abrupt("return", "continue");
                    case 7:
                      _this16.connection.logger.logSchemaBuild("adding new indices ".concat(newIndices.map(function (index) {
                        return "\"".concat(index.name, "\"");
                      }).join(", "), " in table \"").concat(table.name, "\""));
                      _context35.next = 10;
                      return _this16.queryRunner.createIndices(table, newIndices);
                    case 10:
                    case "end":
                      return _context35.stop();
                  }
                }, _loop15);
              });
              _iterator21.s();
            case 4:
              if ((_step21 = _iterator21.n()).done) {
                _context36.next = 11;
                break;
              }
              return _context36.delegateYield(_loop15(), "t0", 6);
            case 6:
              _ret14 = _context36.t0;
              if (!(_ret14 === "continue")) {
                _context36.next = 9;
                break;
              }
              return _context36.abrupt("continue", 9);
            case 9:
              _context36.next = 4;
              break;
            case 11:
              _context36.next = 16;
              break;
            case 13:
              _context36.prev = 13;
              _context36.t1 = _context36["catch"](1);
              _iterator21.e(_context36.t1);
            case 16:
              _context36.prev = 16;
              _iterator21.f();
              return _context36.finish(16);
            case 19:
            case "end":
              return _context36.stop();
          }
        }, _callee21, this, [[1, 13, 16, 19]]);
      }));
      function createNewIndices() {
        return _createNewIndices.apply(this, arguments);
      }
      return createNewIndices;
    }()
    /**
     * Creates indices for materialized views.
     */
  }, {
    key: "createNewViewIndices",
    value: function () {
      var _createNewViewIndices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var _this17 = this;
        var postgresQueryRunner, _iterator22, _step22, _loop16, _ret15;
        return _regeneratorRuntime().wrap(function _callee22$(_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              if (!(this.connection.options.type !== "postgres" || !DriverUtils.isPostgresFamily(this.connection.driver))) {
                _context38.next = 2;
                break;
              }
              return _context38.abrupt("return");
            case 2:
              postgresQueryRunner = this.queryRunner;
              _iterator22 = _createForOfIteratorHelper(this.viewEntityToSyncMetadatas);
              _context38.prev = 4;
              _loop16 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop16() {
                var metadata, view, newIndices;
                return _regeneratorRuntime().wrap(function _loop16$(_context37) {
                  while (1) switch (_context37.prev = _context37.next) {
                    case 0:
                      metadata = _step22.value;
                      // check if view does not exist yet
                      view = _this17.queryRunner.loadedViews.find(function (view) {
                        var viewExpression = typeof view.expression === "string" ? view.expression.trim() : view.expression(_this17.connection).getQuery();
                        var metadataExpression = typeof metadata.expression === "string" ? metadata.expression.trim() : metadata.expression(_this17.connection).getQuery();
                        return _this17.getTablePath(view) === _this17.getTablePath(metadata) && viewExpression === metadataExpression;
                      });
                      if (!(!view || !view.materialized)) {
                        _context37.next = 4;
                        break;
                      }
                      return _context37.abrupt("return", "continue");
                    case 4:
                      newIndices = metadata.indices.filter(function (indexMetadata) {
                        return !view.indices.find(function (tableIndex) {
                          return tableIndex.name === indexMetadata.name;
                        }) && indexMetadata.synchronize === true;
                      }).map(function (indexMetadata) {
                        return TableIndex.create(indexMetadata);
                      });
                      if (!(newIndices.length === 0)) {
                        _context37.next = 7;
                        break;
                      }
                      return _context37.abrupt("return", "continue");
                    case 7:
                      _this17.connection.logger.logSchemaBuild("adding new indices ".concat(newIndices.map(function (index) {
                        return "\"".concat(index.name, "\"");
                      }).join(", "), " in view \"").concat(view.name, "\""));
                      _context37.next = 10;
                      return postgresQueryRunner.createViewIndices(view, newIndices);
                    case 10:
                    case "end":
                      return _context37.stop();
                  }
                }, _loop16);
              });
              _iterator22.s();
            case 7:
              if ((_step22 = _iterator22.n()).done) {
                _context38.next = 14;
                break;
              }
              return _context38.delegateYield(_loop16(), "t0", 9);
            case 9:
              _ret15 = _context38.t0;
              if (!(_ret15 === "continue")) {
                _context38.next = 12;
                break;
              }
              return _context38.abrupt("continue", 12);
            case 12:
              _context38.next = 7;
              break;
            case 14:
              _context38.next = 19;
              break;
            case 16:
              _context38.prev = 16;
              _context38.t1 = _context38["catch"](4);
              _iterator22.e(_context38.t1);
            case 19:
              _context38.prev = 19;
              _iterator22.f();
              return _context38.finish(19);
            case 22:
            case "end":
              return _context38.stop();
          }
        }, _callee22, this, [[4, 16, 19, 22]]);
      }));
      function createNewViewIndices() {
        return _createNewViewIndices.apply(this, arguments);
      }
      return createNewViewIndices;
    }()
  }, {
    key: "createNewChecks",
    value: function () {
      var _createNewChecks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var _this18 = this;
        var _iterator23, _step23, _loop17, _ret16;
        return _regeneratorRuntime().wrap(function _callee23$(_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              if (!(DriverUtils.isMySQLFamily(this.connection.driver) || this.connection.driver.options.type === "aurora-mysql")) {
                _context40.next = 2;
                break;
              }
              return _context40.abrupt("return");
            case 2:
              _iterator23 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context40.prev = 3;
              _loop17 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop17() {
                var metadata, table, newChecks;
                return _regeneratorRuntime().wrap(function _loop17$(_context39) {
                  while (1) switch (_context39.prev = _context39.next) {
                    case 0:
                      metadata = _step23.value;
                      table = _this18.queryRunner.loadedTables.find(function (table) {
                        return _this18.getTablePath(table) === _this18.getTablePath(metadata);
                      });
                      if (table) {
                        _context39.next = 4;
                        break;
                      }
                      return _context39.abrupt("return", "continue");
                    case 4:
                      newChecks = metadata.checks.filter(function (checkMetadata) {
                        return !table.checks.find(function (tableCheck) {
                          return tableCheck.name === checkMetadata.name;
                        });
                      }).map(function (checkMetadata) {
                        return TableCheck.create(checkMetadata);
                      });
                      if (!(newChecks.length === 0)) {
                        _context39.next = 7;
                        break;
                      }
                      return _context39.abrupt("return", "continue");
                    case 7:
                      _this18.connection.logger.logSchemaBuild("adding new check constraints: ".concat(newChecks.map(function (index) {
                        return "\"".concat(index.name, "\"");
                      }).join(", "), " in table \"").concat(table.name, "\""));
                      _context39.next = 10;
                      return _this18.queryRunner.createCheckConstraints(table, newChecks);
                    case 10:
                    case "end":
                      return _context39.stop();
                  }
                }, _loop17);
              });
              _iterator23.s();
            case 6:
              if ((_step23 = _iterator23.n()).done) {
                _context40.next = 13;
                break;
              }
              return _context40.delegateYield(_loop17(), "t0", 8);
            case 8:
              _ret16 = _context40.t0;
              if (!(_ret16 === "continue")) {
                _context40.next = 11;
                break;
              }
              return _context40.abrupt("continue", 11);
            case 11:
              _context40.next = 6;
              break;
            case 13:
              _context40.next = 18;
              break;
            case 15:
              _context40.prev = 15;
              _context40.t1 = _context40["catch"](3);
              _iterator23.e(_context40.t1);
            case 18:
              _context40.prev = 18;
              _iterator23.f();
              return _context40.finish(18);
            case 21:
            case "end":
              return _context40.stop();
          }
        }, _callee23, this, [[3, 15, 18, 21]]);
      }));
      function createNewChecks() {
        return _createNewChecks.apply(this, arguments);
      }
      return createNewChecks;
    }()
    /**
     * Creates composite uniques which are missing in db yet.
     */
  }, {
    key: "createCompositeUniqueConstraints",
    value: function () {
      var _createCompositeUniqueConstraints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
        var _this19 = this;
        var _iterator24, _step24, _loop18, _ret17;
        return _regeneratorRuntime().wrap(function _callee24$(_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _iterator24 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context42.prev = 1;
              _loop18 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop18() {
                var metadata, table, compositeUniques;
                return _regeneratorRuntime().wrap(function _loop18$(_context41) {
                  while (1) switch (_context41.prev = _context41.next) {
                    case 0:
                      metadata = _step24.value;
                      table = _this19.queryRunner.loadedTables.find(function (table) {
                        return _this19.getTablePath(table) === _this19.getTablePath(metadata);
                      });
                      if (table) {
                        _context41.next = 4;
                        break;
                      }
                      return _context41.abrupt("return", "continue");
                    case 4:
                      compositeUniques = metadata.uniques.filter(function (uniqueMetadata) {
                        return uniqueMetadata.columns.length > 1 && !table.uniques.find(function (tableUnique) {
                          return tableUnique.name === uniqueMetadata.name;
                        });
                      }).map(function (uniqueMetadata) {
                        return TableUnique.create(uniqueMetadata);
                      });
                      if (!(compositeUniques.length === 0)) {
                        _context41.next = 7;
                        break;
                      }
                      return _context41.abrupt("return", "continue");
                    case 7:
                      _this19.connection.logger.logSchemaBuild("adding new unique constraints: ".concat(compositeUniques.map(function (unique) {
                        return "\"".concat(unique.name, "\"");
                      }).join(", "), " in table \"").concat(table.name, "\""));
                      _context41.next = 10;
                      return _this19.queryRunner.createUniqueConstraints(table, compositeUniques);
                    case 10:
                    case "end":
                      return _context41.stop();
                  }
                }, _loop18);
              });
              _iterator24.s();
            case 4:
              if ((_step24 = _iterator24.n()).done) {
                _context42.next = 11;
                break;
              }
              return _context42.delegateYield(_loop18(), "t0", 6);
            case 6:
              _ret17 = _context42.t0;
              if (!(_ret17 === "continue")) {
                _context42.next = 9;
                break;
              }
              return _context42.abrupt("continue", 9);
            case 9:
              _context42.next = 4;
              break;
            case 11:
              _context42.next = 16;
              break;
            case 13:
              _context42.prev = 13;
              _context42.t1 = _context42["catch"](1);
              _iterator24.e(_context42.t1);
            case 16:
              _context42.prev = 16;
              _iterator24.f();
              return _context42.finish(16);
            case 19:
            case "end":
              return _context42.stop();
          }
        }, _callee24, this, [[1, 13, 16, 19]]);
      }));
      function createCompositeUniqueConstraints() {
        return _createCompositeUniqueConstraints.apply(this, arguments);
      }
      return createCompositeUniqueConstraints;
    }()
    /**
     * Creates exclusions which are missing in db yet.
     */
  }, {
    key: "createNewExclusions",
    value: function () {
      var _createNewExclusions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
        var _this20 = this;
        var _iterator25, _step25, _loop19, _ret18;
        return _regeneratorRuntime().wrap(function _callee25$(_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              if (this.connection.driver.options.type === "postgres") {
                _context44.next = 2;
                break;
              }
              return _context44.abrupt("return");
            case 2:
              _iterator25 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context44.prev = 3;
              _loop19 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop19() {
                var metadata, table, newExclusions;
                return _regeneratorRuntime().wrap(function _loop19$(_context43) {
                  while (1) switch (_context43.prev = _context43.next) {
                    case 0:
                      metadata = _step25.value;
                      table = _this20.queryRunner.loadedTables.find(function (table) {
                        return _this20.getTablePath(table) === _this20.getTablePath(metadata);
                      });
                      if (table) {
                        _context43.next = 4;
                        break;
                      }
                      return _context43.abrupt("return", "continue");
                    case 4:
                      newExclusions = metadata.exclusions.filter(function (exclusionMetadata) {
                        return !table.exclusions.find(function (tableExclusion) {
                          return tableExclusion.name === exclusionMetadata.name;
                        });
                      }).map(function (exclusionMetadata) {
                        return TableExclusion.create(exclusionMetadata);
                      });
                      if (!(newExclusions.length === 0)) {
                        _context43.next = 7;
                        break;
                      }
                      return _context43.abrupt("return", "continue");
                    case 7:
                      _this20.connection.logger.logSchemaBuild("adding new exclusion constraints: ".concat(newExclusions.map(function (exclusion) {
                        return "\"".concat(exclusion.name, "\"");
                      }).join(", "), " in table \"").concat(table.name, "\""));
                      _context43.next = 10;
                      return _this20.queryRunner.createExclusionConstraints(table, newExclusions);
                    case 10:
                    case "end":
                      return _context43.stop();
                  }
                }, _loop19);
              });
              _iterator25.s();
            case 6:
              if ((_step25 = _iterator25.n()).done) {
                _context44.next = 13;
                break;
              }
              return _context44.delegateYield(_loop19(), "t0", 8);
            case 8:
              _ret18 = _context44.t0;
              if (!(_ret18 === "continue")) {
                _context44.next = 11;
                break;
              }
              return _context44.abrupt("continue", 11);
            case 11:
              _context44.next = 6;
              break;
            case 13:
              _context44.next = 18;
              break;
            case 15:
              _context44.prev = 15;
              _context44.t1 = _context44["catch"](3);
              _iterator25.e(_context44.t1);
            case 18:
              _context44.prev = 18;
              _iterator25.f();
              return _context44.finish(18);
            case 21:
            case "end":
              return _context44.stop();
          }
        }, _callee25, this, [[3, 15, 18, 21]]);
      }));
      function createNewExclusions() {
        return _createNewExclusions.apply(this, arguments);
      }
      return createNewExclusions;
    }()
    /**
     * Creates foreign keys which does not exist in the table yet.
     */
  }, {
    key: "createForeignKeys",
    value: function () {
      var _createForeignKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
        var _this21 = this;
        var _iterator26, _step26, _loop20, _ret19;
        return _regeneratorRuntime().wrap(function _callee26$(_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              _iterator26 = _createForOfIteratorHelper(this.entityToSyncMetadatas);
              _context46.prev = 1;
              _loop20 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop20() {
                var metadata, table, newKeys, dbForeignKeys;
                return _regeneratorRuntime().wrap(function _loop20$(_context45) {
                  while (1) switch (_context45.prev = _context45.next) {
                    case 0:
                      metadata = _step26.value;
                      table = _this21.queryRunner.loadedTables.find(function (table) {
                        return _this21.getTablePath(table) === _this21.getTablePath(metadata);
                      });
                      if (table) {
                        _context45.next = 4;
                        break;
                      }
                      return _context45.abrupt("return", "continue");
                    case 4:
                      newKeys = metadata.foreignKeys.filter(function (foreignKey) {
                        return !table.foreignKeys.find(function (dbForeignKey) {
                          return dbForeignKey.name === foreignKey.name && _this21.getTablePath(dbForeignKey) === _this21.getTablePath(foreignKey.referencedEntityMetadata);
                        });
                      });
                      if (!(newKeys.length === 0)) {
                        _context45.next = 7;
                        break;
                      }
                      return _context45.abrupt("return", "continue");
                    case 7:
                      dbForeignKeys = newKeys.map(function (foreignKeyMetadata) {
                        return TableForeignKey.create(foreignKeyMetadata, _this21.connection.driver);
                      });
                      _this21.connection.logger.logSchemaBuild("creating a foreign keys: ".concat(newKeys.map(function (key) {
                        return key.name;
                      }).join(", "), " on table \"").concat(table.name, "\""));
                      _context45.next = 11;
                      return _this21.queryRunner.createForeignKeys(table, dbForeignKeys);
                    case 11:
                    case "end":
                      return _context45.stop();
                  }
                }, _loop20);
              });
              _iterator26.s();
            case 4:
              if ((_step26 = _iterator26.n()).done) {
                _context46.next = 11;
                break;
              }
              return _context46.delegateYield(_loop20(), "t0", 6);
            case 6:
              _ret19 = _context46.t0;
              if (!(_ret19 === "continue")) {
                _context46.next = 9;
                break;
              }
              return _context46.abrupt("continue", 9);
            case 9:
              _context46.next = 4;
              break;
            case 11:
              _context46.next = 16;
              break;
            case 13:
              _context46.prev = 13;
              _context46.t1 = _context46["catch"](1);
              _iterator26.e(_context46.t1);
            case 16:
              _context46.prev = 16;
              _iterator26.f();
              return _context46.finish(16);
            case 19:
            case "end":
              return _context46.stop();
          }
        }, _callee26, this, [[1, 13, 16, 19]]);
      }));
      function createForeignKeys() {
        return _createForeignKeys.apply(this, arguments);
      }
      return createForeignKeys;
    }()
    /**
     * Drops all foreign keys where given column of the given table is being used.
     */
  }, {
    key: "dropColumnReferencedForeignKeys",
    value: function () {
      var _dropColumnReferencedForeignKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(tablePath, columnName) {
        var _this22 = this;
        var table, tablesWithFK, columnForeignKey, clonedTable, _iterator27, _step27, _loop21, _iterator28, _step28, tableWithFK;
        return _regeneratorRuntime().wrap(function _callee27$(_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              table = this.queryRunner.loadedTables.find(function (table) {
                return _this22.getTablePath(table) === tablePath;
              });
              if (table) {
                _context48.next = 3;
                break;
              }
              return _context48.abrupt("return");
            case 3:
              tablesWithFK = [];
              columnForeignKey = table.foreignKeys.find(function (foreignKey) {
                return foreignKey.columnNames.indexOf(columnName) !== -1;
              });
              if (columnForeignKey) {
                clonedTable = table.clone();
                clonedTable.foreignKeys = [columnForeignKey];
                tablesWithFK.push(clonedTable);
                table.removeForeignKey(columnForeignKey);
              }
              _iterator27 = _createForOfIteratorHelper(this.queryRunner.loadedTables);
              _context48.prev = 7;
              _loop21 = /*#__PURE__*/_regeneratorRuntime().mark(function _loop21() {
                var loadedTable, dependForeignKeys, _clonedTable;
                return _regeneratorRuntime().wrap(function _loop21$(_context47) {
                  while (1) switch (_context47.prev = _context47.next) {
                    case 0:
                      loadedTable = _step27.value;
                      dependForeignKeys = loadedTable.foreignKeys.filter(function (foreignKey) {
                        return _this22.getTablePath(foreignKey) === tablePath && foreignKey.referencedColumnNames.indexOf(columnName) !== -1;
                      });
                      if (dependForeignKeys.length > 0) {
                        _clonedTable = loadedTable.clone();
                        _clonedTable.foreignKeys = dependForeignKeys;
                        tablesWithFK.push(_clonedTable);
                        dependForeignKeys.forEach(function (dependForeignKey) {
                          return loadedTable.removeForeignKey(dependForeignKey);
                        });
                      }
                    case 3:
                    case "end":
                      return _context47.stop();
                  }
                }, _loop21);
              });
              _iterator27.s();
            case 10:
              if ((_step27 = _iterator27.n()).done) {
                _context48.next = 14;
                break;
              }
              return _context48.delegateYield(_loop21(), "t0", 12);
            case 12:
              _context48.next = 10;
              break;
            case 14:
              _context48.next = 19;
              break;
            case 16:
              _context48.prev = 16;
              _context48.t1 = _context48["catch"](7);
              _iterator27.e(_context48.t1);
            case 19:
              _context48.prev = 19;
              _iterator27.f();
              return _context48.finish(19);
            case 22:
              if (!(tablesWithFK.length > 0)) {
                _context48.next = 41;
                break;
              }
              _iterator28 = _createForOfIteratorHelper(tablesWithFK);
              _context48.prev = 24;
              _iterator28.s();
            case 26:
              if ((_step28 = _iterator28.n()).done) {
                _context48.next = 33;
                break;
              }
              tableWithFK = _step28.value;
              this.connection.logger.logSchemaBuild("dropping related foreign keys of ".concat(tableWithFK.name, ": ").concat(tableWithFK.foreignKeys.map(function (foreignKey) {
                return foreignKey.name;
              }).join(", ")));
              _context48.next = 31;
              return this.queryRunner.dropForeignKeys(tableWithFK, tableWithFK.foreignKeys);
            case 31:
              _context48.next = 26;
              break;
            case 33:
              _context48.next = 38;
              break;
            case 35:
              _context48.prev = 35;
              _context48.t2 = _context48["catch"](24);
              _iterator28.e(_context48.t2);
            case 38:
              _context48.prev = 38;
              _iterator28.f();
              return _context48.finish(38);
            case 41:
            case "end":
              return _context48.stop();
          }
        }, _callee27, this, [[7, 16, 19, 22], [24, 35, 38, 41]]);
      }));
      function dropColumnReferencedForeignKeys(_x4, _x5) {
        return _dropColumnReferencedForeignKeys.apply(this, arguments);
      }
      return dropColumnReferencedForeignKeys;
    }()
    /**
     * Drops all composite indices, related to given column.
     */
  }, {
    key: "dropColumnCompositeIndices",
    value: function () {
      var _dropColumnCompositeIndices = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28(tablePath, columnName) {
        var _this23 = this;
        var table, relatedIndices;
        return _regeneratorRuntime().wrap(function _callee28$(_context49) {
          while (1) switch (_context49.prev = _context49.next) {
            case 0:
              table = this.queryRunner.loadedTables.find(function (table) {
                return _this23.getTablePath(table) === tablePath;
              });
              if (table) {
                _context49.next = 3;
                break;
              }
              return _context49.abrupt("return");
            case 3:
              relatedIndices = table.indices.filter(function (index) {
                return index.columnNames.length > 1 && index.columnNames.indexOf(columnName) !== -1;
              });
              if (!(relatedIndices.length === 0)) {
                _context49.next = 6;
                break;
              }
              return _context49.abrupt("return");
            case 6:
              this.connection.logger.logSchemaBuild("dropping related indices of \"".concat(tablePath, "\".\"").concat(columnName, "\": ").concat(relatedIndices.map(function (index) {
                return index.name;
              }).join(", ")));
              _context49.next = 9;
              return this.queryRunner.dropIndices(table, relatedIndices);
            case 9:
            case "end":
              return _context49.stop();
          }
        }, _callee28, this);
      }));
      function dropColumnCompositeIndices(_x6, _x7) {
        return _dropColumnCompositeIndices.apply(this, arguments);
      }
      return dropColumnCompositeIndices;
    }()
    /**
     * Drops all composite uniques, related to given column.
     */
  }, {
    key: "dropColumnCompositeUniques",
    value: function () {
      var _dropColumnCompositeUniques = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29(tablePath, columnName) {
        var _this24 = this;
        var table, relatedUniques;
        return _regeneratorRuntime().wrap(function _callee29$(_context50) {
          while (1) switch (_context50.prev = _context50.next) {
            case 0:
              table = this.queryRunner.loadedTables.find(function (table) {
                return _this24.getTablePath(table) === tablePath;
              });
              if (table) {
                _context50.next = 3;
                break;
              }
              return _context50.abrupt("return");
            case 3:
              relatedUniques = table.uniques.filter(function (unique) {
                return unique.columnNames.length > 1 && unique.columnNames.indexOf(columnName) !== -1;
              });
              if (!(relatedUniques.length === 0)) {
                _context50.next = 6;
                break;
              }
              return _context50.abrupt("return");
            case 6:
              this.connection.logger.logSchemaBuild("dropping related unique constraints of \"".concat(tablePath, "\".\"").concat(columnName, "\": ").concat(relatedUniques.map(function (unique) {
                return unique.name;
              }).join(", ")));
              _context50.next = 9;
              return this.queryRunner.dropUniqueConstraints(table, relatedUniques);
            case 9:
            case "end":
              return _context50.stop();
          }
        }, _callee29, this);
      }));
      function dropColumnCompositeUniques(_x8, _x9) {
        return _dropColumnCompositeUniques.apply(this, arguments);
      }
      return dropColumnCompositeUniques;
    }()
    /**
     * Creates new columns from the given column metadatas.
     */
  }, {
    key: "metadataColumnsToTableColumnOptions",
    value: function metadataColumnsToTableColumnOptions(columns) {
      var _this25 = this;
      return columns.map(function (columnMetadata) {
        return TableUtils.createTableColumnOptions(columnMetadata, _this25.connection.driver);
      });
    }
    /**
     * Creates typeorm service table for storing user defined Views and generate columns.
     */
  }, {
    key: "createTypeormMetadataTable",
    value: function () {
      var _createTypeormMetadataTable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(queryRunner) {
        var schema, database, typeormMetadataTable, isPrimary;
        return _regeneratorRuntime().wrap(function _callee30$(_context51) {
          while (1) switch (_context51.prev = _context51.next) {
            case 0:
              schema = this.currentSchema;
              database = this.currentDatabase;
              typeormMetadataTable = this.connection.driver.buildTableName(this.connection.metadataTableName, schema, database); // Spanner requires at least one primary key in a table.
              // Since we don't have unique column in "typeorm_metadata" table
              // and we should avoid breaking changes, we mark all columns as primary for Spanner driver.
              isPrimary = this.connection.driver.options.type === "spanner";
              _context51.next = 6;
              return queryRunner.createTable(new Table({
                database: database,
                schema: schema,
                name: typeormMetadataTable,
                columns: [{
                  name: "type",
                  type: this.connection.driver.normalizeType({
                    type: this.connection.driver.mappedDataTypes.metadataType
                  }),
                  isNullable: false,
                  isPrimary: isPrimary
                }, {
                  name: "database",
                  type: this.connection.driver.normalizeType({
                    type: this.connection.driver.mappedDataTypes.metadataDatabase
                  }),
                  isNullable: true,
                  isPrimary: isPrimary
                }, {
                  name: "schema",
                  type: this.connection.driver.normalizeType({
                    type: this.connection.driver.mappedDataTypes.metadataSchema
                  }),
                  isNullable: true,
                  isPrimary: isPrimary
                }, {
                  name: "table",
                  type: this.connection.driver.normalizeType({
                    type: this.connection.driver.mappedDataTypes.metadataTable
                  }),
                  isNullable: true,
                  isPrimary: isPrimary
                }, {
                  name: "name",
                  type: this.connection.driver.normalizeType({
                    type: this.connection.driver.mappedDataTypes.metadataName
                  }),
                  isNullable: true,
                  isPrimary: isPrimary
                }, {
                  name: "value",
                  type: this.connection.driver.normalizeType({
                    type: this.connection.driver.mappedDataTypes.metadataValue
                  }),
                  isNullable: true,
                  isPrimary: isPrimary
                }]
              }), true);
            case 6:
            case "end":
              return _context51.stop();
          }
        }, _callee30, this);
      }));
      function createTypeormMetadataTable(_x10) {
        return _createTypeormMetadataTable.apply(this, arguments);
      }
      return createTypeormMetadataTable;
    }()
  }]);
  return RdbmsSchemaBuilder;
}();